import React, { useState } from 'react';
import { RootStateOrAny, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import email from '../../../assets/email.svg';
import forgotImg from '../../../assets/forgot_password.svg';
import { resetForgotPassword } from '../../../auth/Auth';
import Button from '../../../components/Button';
import TextInput from '../../../components/TextInput';
import { SIGN_IN_FORM } from '../../../constants/FormNames';
import { checkHasErrors } from '../../../constants/Validations';
import { ValidationTypes } from '../../../enums/ValidationTypes';

const Forgot = () => {
	const msg = {
		success:
			'An email has been sent to your email address, and click the reset link provided!',
		notFound: 'No account found under this email address',
	};

	const navigate = useHistory();
	const [err, setErr] = useState(false);
	const [emailSent, setemailSent] = useState(false);
	const form = useSelector(
		(state: RootStateOrAny) => state?.forms?.[SIGN_IN_FORM]?.values
	);
	const handleReset = () => {
		resetForgotPassword(
			form?.email,
			() => {
				setemailSent(true);
			},
			() => {
				setemailSent(true);
				setErr(true);
			}
		);
	};

	const disabled = () => {
		return checkHasErrors(SIGN_IN_FORM, ['email']) || err;
	};

	return (
		<div className='signup__container'>
			<div className='signup__box forgot-box'>
				<p className='company__name'>
					<p onClick={() => navigate.push('/home')}>Webbler</p>
				</p>
				<p className='signup_text'>
					New user? <p onClick={() => navigate.push('/signup')}>Sign up</p>
				</p>
				<div className='box'>
					<div className='img_wrap'>
						<img className='login_img' src={forgotImg} alt='Login image' />
					</div>
					<div className='form'>
						<div className='text_box'>
							<h3 className='welcome'>Forgot Password?</h3>
							<h6 className='welcome_sub1'>reset your password</h6>
						</div>
						<div>
							<div className='inputbox-container'>
								<div className='input_box'>
									<TextInput
										onFocus={() => setErr(false)}
										type='email'
										name='email'
										transform='lower'
										id='username'
										placeholder='Email'
										form={SIGN_IN_FORM}
										validations={[ValidationTypes.email, ValidationTypes.required]}
										mainIcon={email}
									/>
								</div>
							</div>
						</div>
						<div className='bottom_group'>
							<div>
								<div className='btn_box forget_button'>
									<Button
										active
										diactivated={disabled()}
										clicked={false}
										className='forget-btn'
										labal={'Send password reset link'}
										onClickEvent={() => handleReset()}
									/>
								</div>
							</div>

							<div className='signup_bottom'>
								Already have an account?{' '}
								<span onClick={() => navigate.push('/login')}>Sign in</span>
							</div>
						</div>
						<span className={`reset_email_sent ${err ? 'error' : ''}`}>
							{!err && emailSent ? msg.success : emailSent && err ? msg.notFound : ''}
						</span>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Forgot;
